<template>
  <v-container fluid grid-list-lg>
    <v-layout row wrap>
      <v-flex xs12 sm8 offset-sm2 pt-5>

        <v-alert :value="true"  v-if="error != null" type="error" >{{ error.message }}</v-alert>
        <v-alert :value="true"  v-if="success != null" type="success" >{{ success.message }}</v-alert>

        <v-layout justify-center column>
          <template v-if="ready">
            <v-form ref="form" v-model="valid" lazy-validation @submit="updateUser" >

              <p class="heading-copy">Let us know what you want to hear about, and how you want to hear from us. You can update your preferences at any time. To opt-out of all communications, simply untick all boxes and save.</p>

              <div class="select-all-row">
                <v-switch
                  :label="`Select all`"
                  v-model="selectAll"
                  color="#5bb57c"
                  @change="onSelectAllChange"
                ></v-switch>
              </div>

              <div class="prefs-table">
                <div class="prefs-header">
                  <div class="prefs-cell prefs-area-header"></div>
                  <div class="prefs-cell prefs-channel-header">Email</div>
                  <div class="prefs-cell prefs-channel-header">SMS</div>
                </div>

                <div class="prefs-row">
                  <div class="prefs-cell prefs-area-label">
                    <strong>Stoke City Football Club</strong>
                    <span class="prefs-area-description">The latest news, ticketing, retail updates and behind the scenes content from Stoke City Football Club.</span>
                  </div>
                  <div class="prefs-cell">
                    <v-checkbox v-model="clubEmail" color="#5bb57c" hide-details @change="updateSelectAll"></v-checkbox>
                  </div>
                  <div class="prefs-cell">
                    <v-checkbox v-model="clubSMS" color="#5bb57c" hide-details @change="updateSelectAll"></v-checkbox>
                  </div>
                </div>

                <div class="prefs-row">
                  <div class="prefs-cell prefs-area-label">
                    <strong>Stoke City Women</strong>
                    <span class="prefs-area-description">Receive news, content and information regarding Stoke City's women's team.</span>
                  </div>
                  <div class="prefs-cell">
                    <v-checkbox v-model="womensEmail" color="#5bb57c" hide-details @change="updateSelectAll"></v-checkbox>
                  </div>
                  <div class="prefs-cell">
                    <v-checkbox v-model="womensSMS" color="#5bb57c" hide-details @change="updateSelectAll"></v-checkbox>
                  </div>
                </div>

                <div class="prefs-row">
                  <div class="prefs-cell prefs-area-label">
                    <strong>Stoke City Foundation</strong>
                    <span class="prefs-area-description">Hear about community activities, programmes, charity fundraising and opportunities for everyone to play football and be active.</span>
                  </div>
                  <div class="prefs-cell">
                    <v-checkbox v-model="foundationEmail" color="#5bb57c" hide-details @change="updateSelectAll"></v-checkbox>
                  </div>
                  <div class="prefs-cell">
                    <v-checkbox v-model="foundationSMS" color="#5bb57c" hide-details @change="updateSelectAll"></v-checkbox>
                  </div>
                </div>

                <div class="prefs-row">
                  <div class="prefs-cell prefs-area-label">
                    <strong>Events</strong>
                    <span class="prefs-area-description">Keep up to date with what's on at the bet365 Stadium on non-matchdays (e.g. concerts, dinners, conferences and
other entertainment events).</span>
                  </div>
                  <div class="prefs-cell">
                    <v-checkbox v-model="eventsEmail" color="#5bb57c" hide-details @change="updateSelectAll"></v-checkbox>
                  </div>
                  <div class="prefs-cell">
                    <v-checkbox v-model="eventsSMS" color="#5bb57c" hide-details @change="updateSelectAll"></v-checkbox>
                  </div>
                </div>

                <div class="prefs-row">
                  <div class="prefs-cell prefs-area-label">
                    <strong>Partners</strong>
                    <span class="prefs-area-description">We occasionally send offers on behalf of our carefully selected partners, but do not share your information directly with them.</span>
                  </div>
                  <div class="prefs-cell">
                    <v-checkbox v-model="partnerEmail" color="#5bb57c" hide-details @change="updateSelectAll"></v-checkbox>
                  </div>
                  <div class="prefs-cell">
                    <v-checkbox v-model="partnerSMS" color="#5bb57c" hide-details @change="updateSelectAll"></v-checkbox>
                  </div>
                </div>
              </div>

              <v-layout row align-center mx-1 mt-5>
                <v-spacer />
                <button type="submit" class="button" :disabled="!valid || !ready">Save Preferences</button>
              </v-layout>

            </v-form>
          </template>

          <template v-else>
            <div class="text-xs-center">
              <v-progress-circular
              :size="50"
              color="accent"
              indeterminate
              ></v-progress-circular>
            </div>
          </template>
        </v-layout>

      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import axios from 'axios'
export default {
  name: 'UserProfileContactPrefs',
  data () {

    return {
      ready: false,
      valid: true,
      selectAll: false,
      clubEmail: false,
      clubSMS: false,
      womensEmail: false,
      womensSMS: false,
      foundationEmail: false,
      foundationSMS: false,
      eventsEmail: false,
      eventsSMS: false,
      partnerEmail: false,
      partnerSMS: false,
      error: null,
      success: null,
      loading: false
    }
  },
  created () {
    // load this user's latest information
    this.$getCurrentUserAttributes().subscribe((userData) => {

        this.clubEmail = (userData['custom:club_email'] == "true")
        this.clubSMS = (userData['custom:club_sms'] == "true")
        this.womensEmail = (userData['custom:womens_email'] == "true")
        this.womensSMS = (userData['custom:womens_sms'] == "true")
        this.foundationEmail = (userData['custom:foundation_email'] == "true")
        this.foundationSMS = (userData['custom:foundation_sms'] == "true")
        this.eventsEmail = (userData['custom:events_email'] == "true")
        this.eventsSMS = (userData['custom:events_sms'] == "true")
        this.partnerEmail = (userData['custom:partner_email'] == "true")
        this.partnerSMS = (userData['custom:partner_sms'] == "true")

        this.updateSelectAll()
        // tell the app that we've finished loading
        this.ready = true

    },
    (err)=> {
        console.log('Unable to load user profile, session may not be present.')
    });

  },
  methods: {
    onSelectAllChange (val) {
      this.clubEmail = val
      this.clubSMS = val
      this.womensEmail = val
      this.womensSMS = val
      this.foundationEmail = val
      this.foundationSMS = val
      this.eventsEmail = val
      this.eventsSMS = val
      this.partnerEmail = val
      this.partnerSMS = val
    },
    updateSelectAll () {
      this.selectAll = this.clubEmail && this.clubSMS &&
        this.womensEmail && this.womensSMS &&
        this.foundationEmail && this.foundationSMS &&
        this.eventsEmail && this.eventsSMS &&
        this.partnerEmail && this.partnerSMS
    },
    updateUser (e) {
        e.preventDefault()
        this.ready = false

        var attributesList = {
            "custom:club_email": this.clubEmail.toString(),
            "custom:club_sms": this.clubSMS.toString(),
            "custom:womens_email": this.womensEmail.toString(),
            "custom:womens_sms": this.womensSMS.toString(),
            "custom:foundation_email": this.foundationEmail.toString(),
            "custom:foundation_sms": this.foundationSMS.toString(),
            "custom:events_email": this.eventsEmail.toString(),
            "custom:events_sms": this.eventsSMS.toString(),
            "custom:partner_email": this.partnerEmail.toString(),
            "custom:partner_sms": this.partnerSMS.toString(),
        }

        this.$updateAttributes(attributesList).subscribe((response) => {
          console.log("update successful")
          this.error = null
          this.success = response
          this.ready = true

          this.$getSession().subscribe((sessionData) => {
            console.log('Session data', sessionData)
            // Post Data to SeatGeek's server (using the id Token)
            var vm = this
            setTimeout(function () {
              var lastSub = vm.$cookie.get(`CognitoIdentityServiceProvider.${process.env.VUE_APP_AWS_CLIENT_ID}.LastAuthUser`)
              var idToken = vm.$cookie.get(`CognitoIdentityServiceProvider.${process.env.VUE_APP_AWS_CLIENT_ID}.${lastSub}.idToken`)
              axios.post(`${process.env.VUE_APP_SEATGEEK_SRO_ENDPOINT}`, idToken ).then(function (seatGeekResponse) {
                // Tell our parent window that the profile has been updated (if one exists)
                if(window.opener){
                  console.log('sending profileUpdated postMessage')
                  window.opener.postMessage('profileUpdated', '*');
                }
              }).catch(function (error) {
                // Tell our parent window that the profile has been updated (if one exists)
                if(window.opener){
                  console.log('sending profileUpdated postMessage')
                  window.opener.postMessage('profileUpdated', '*');
                }
              })
            }, 500);
          },(err)=> {
                console.log('Unable to load user session data')
          });

        },
        (err)=> {
            //if we get an UnkownError it is more than likely because the user has a status of 'FORCE_CHANGE_PASSWORD' in AWS Cognito
            console.log(err.message)
            this.success = null
            this.error = err
            this.ready = true
        });
    }
  }
}
</script>

<style scoped>
  .select-all-row {
    border: 2px solid #be0f34;
    border-radius: 4px;
    padding: 0 16px;
    margin-bottom: 24px;
    text-align: center;
  }

  .prefs-table {
    width: 100%;
  }

  .prefs-header {
    display: flex;
    align-items: center;
    padding: 8px 0;
    border-bottom: 2px solid #be0f34;
    font-weight: bold;
    text-transform: uppercase;
    font-size: 13px;
    color: #333;
  }

  .prefs-row {
    display: flex;
    align-items: center;
    padding: 4px 0;
    border-bottom: 1px solid #EEEEEE;
  }

  .prefs-cell {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .prefs-cell .v-input--checkbox {
    margin: 0;
    padding: 0;
    justify-content: center;
  }

  .prefs-cell .v-input--selection-controls__input {
    margin: 0 auto;
  }

  .prefs-area-header,
  .prefs-area-label {
    flex: 2;
    justify-content: flex-start;
  }

  .prefs-area-label {
    flex-direction: column;
    align-items: flex-start;
    font-size: 16px;
    color: #1a1a1a;
  }

  .prefs-area-label strong {
    font-weight: bold;
  }

  .prefs-area-description {
    display: block;
    font-size: 12px;
    line-height: 16px;
    color: #666;
    font-weight: normal;
    margin-top: 2px;
  }

  .prefs-channel-header {
    text-align: center;
  }
</style>